<template>
    <h2>Ajouter une information</h2>
    <div class="add-info">
      <form @submit.prevent="submitForm">
        <label>Nom :</label>
        <input type="text" v-model="form.name" required />

        <label>Image :</label>
        <input type="file" @change="handleFile" accept=".pdf" />
  
        <button type="submit">Ajouter</button>
      </form>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'AddInfoForm',
    data() {
      return {
        form: {
          name: '',
        },
        file: null,
      };
    },
    computed: {
      ...mapGetters(['getCategories', 'getPlaces']),
      allCategories() {
        return this.getCategories;
      },
      allLieux() {
        return this.getPlaces;
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      handleFile(event) {
        this.file = event.target.files[0];
      },
      submitForm() {
        const formData = new FormData();
        if (this.file) {
          formData.append('file', this.file);
        }
        const infoUpload = {
          name: this.form.name,
        };
        formData.append('infoUpload', JSON.stringify(infoUpload));
        this.$store.dispatch('uploadInfo', formData);
      }
    }
  };
  </script>
  
  <style scoped>
  .add-info {
    background-color: #F8F8FF;
    border-radius: 10px;
    padding: 2rem;
    border: 1px solid #ccc;
    text-align: left;
  }
  
  form {
    display: flex;
    flex-direction: column;
  }
  
  label {
    font-weight: bold;
    margin-top: 1rem;
    margin-bottom: 0.25rem;
    color: #5E3B80;
  }
  
  input[type="text"],
  input[type="number"],
  .text-editor,
  .ql-container {
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
    width: 100%;
  }
  
  .text-editor {
    min-height: 150px;
    resize: vertical;
    overflow-y: auto;
  }
  
  .checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 0.5rem;
  }
  
  .checkbox-group label {
    margin-left: 0.5rem;
    font-weight: normal;
    color: #333;
  }
  
  button {
    margin-top: 2rem;
    background-color: #167580;
    color: white;
    border: none;
    padding: 0.75rem;
    font-weight: bold;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  button:hover {
    background-color: #1E1C66;
  }
  </style>
  